// 封装axios，实现api的统一管理
import axios from 'axios';
import { ElMessage } from 'element-plus';  // 引入ElMessage组件 消息提醒

// 创建axios实例    利用create方法
const instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // axios中请求配置有baseURL选项，表示请求URL公共部分
    timeout:15000, // 响应时间/请求超时时间，设置15秒
})

// axios拦截器  用于我们在发送请求或者得到响应后，进行对应的处理。
// 请求拦截器  拿到axios实例进行 request 拦截    用于在请求发送之前做一些处理 
// use表示使用拦截。看源码，可以看到use的几个参数都是可选的
// 这里写了两个参数，一个是请求成功的，一个是请求失败的。config和err的名称可以自定义，它们只是参数而已。
instance.interceptors.request.use(config=>{
    /**
     * 那么，一般请求拦截，我们会做什么事情呢？  
     * 1、比如config中的一些信息不符合服务器的要求。 
     *      服务器返回的header中默认给我们加了内容，但是我们不想要这个内容，那么就可以修改header 
     * 
     * 2、比如每次发送网络请求时，都希望在界面中显示一个请求的图标
     * 
     * 3、比如某些网络请求（例如登录 token)，必须携带一些特殊的信息
     */
    // 成功就直接返回 
    // 注意：这里务必要返回config配置对象，否则请求就停在这里出不去了。（记住：一定要把config原封不动地return出去才行！！！）
    return config;
},err =>{  // 请求错误处理
    return Promise.reject(err)
})

// 响应拦截器 拿到axios实例进行 response 拦截  
instance.interceptors.response.use(result=>{
    // console.log('响应拦截成功！')
    // 响应成功  
    // 最终返回result中的data值，后端返回的数据在data中
    return result.data;
},err=>{
    if(err.response){
        const { status } = err.response; // 响应状态码
        if(status === 400){
            ElMessage.error('请求参数错误！');
        }
        else if(status === 401){
            ElMessage.error('未授权！');
        }
        else if(status === 403){
            ElMessage.error('服务器拒绝访问！');
        }
        else if(status === 500){
            ElMessage.error('服务器错误！');
        }
        else if(status === 502){
            ElMessage.error('网络错误！')
        }
        else if(status === 504){
           ElMessage.error('网络超时！')
        }
    }else if(err.request){
        // 请求已发送，但没有收到响应 
        ElMessage.error('网络错误，请检查网络连接！');
        return Promise.reject('网络错误，请检查网络连接！')
    }else{
        // 其他错误
        ElMessage.error(err.message);
        return Promise.reject(err.message);
    }
    // 响应失败  
    // return Promise.reject(err);
})

// 导出一个axios实例
export default instance;

// 扩展：如果想导出多个axios实例，就这么写
// export function instance(){};
// export function instance1(){};